<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="标题">
              <a-input placeholder="请输入标题" v-model="where.keyword.title" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <!-- <a-form-item label="栏目">
              <a-select defaultValue v-model="where.keyword.cate">
                <a-select-option
                  :value="item.name"
                  v-for="(item,index) in where.cateData"
                  :key="index"
                >{{item.name}}</a-select-option>
            
              </a-select>
            </a-form-item> -->
              <a-form-item label="栏目">
              <a-cascader
                allowClear
                changeOnSelect
                :fieldNames="{ label: 'name', value: 'name', children: 'list' }"
                :options="where.keyword.cateArr"
                @change="treeChange"
                placeholder="请选择"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="状态">
              <a-select defaultValue v-model="where.keyword.status">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">启用</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-button type="primary" @click="searchList" v-btnlimit="'已审文章-搜索'">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
          </a-col>
        </a-row>
      
      </a-form>
    </div>

    <div class="pxkeji-right-box">
     
      <pxkeji-btn
        name="批量启用"
        v-if="selectRows.length>0"
        v-btnlimit="'已审文章-批量启用'"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        v-if="selectRows.length>0"
        v-btnlimit="'已审文章-批量禁用'"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />
      <pxkeji-btn name="批量删除" @click="batchDelete" v-if="selectRows.length>0" class="pxkeji_basic_btn" v-btnlimit="'已审文章-批量删除'"/>

      <a-alert type="info" showIcon style="margin-bottom:20px;">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >

        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="auditstatus" slot-scope="auditstatus">
          <a-tag v-if="auditstatus==1" color="green">已发布</a-tag>
          <a-tag v-else-if="auditstatus==2" color="red">已拒绝</a-tag>
        </span>
        <span slot="priority" slot-scope="priority">
          <a-tag v-if="priority==-1" color="green">置顶</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="预览" @click="showInfo(action,1)" size="small" type="primary" />
          <a-divider type="vertical" />
          <a-dropdown>
            <a-menu slot="overlay">
             
              <a-menu-item key="1" v-if="action.auditstatus==1">
                <pxkeji-btn
                  name="反审"
                  v-btnlimit="'已审文章-反审'"
                  @click="recheckInfo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                  name="禁用"
                  v-btnlimit="'已审文章-启用禁用'"
                  @click="handleStatus(action.id,0)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  v-btnlimit="'已审文章-启用禁用'"
                  @click="handleStatus(action.id,1)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-else
                />
              </a-menu-item>
              <a-menu-item key="3">
                <pxkeji-btn
                  name="删除"
                  v-btnlimit="'已审文章-删除'"
                  @click="delInfo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="4">
                <pxkeji-btn
                  name="置顶"
                  v-btnlimit="'已审文章-置顶'"
                  @click="top(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
               <a-menu-item key="5">
                <pxkeji-btn
                  name="SEO配置"
                   v-btnlimit="'已审文章-SEO配置'"
                  @click="setSeo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
                 <a-menu-item key="6">
                      <pxkeji-btn
                              name="上移"
                              v-btnlimit="'已审文章-上移'"
                              @click="handlemoveup(action.id)"
                              size="small"
                              type="default"
                              class="pxkeji_dro_btn"
                      />
              </a-menu-item>
              <a-menu-item key="7" >
                <pxkeji-btn
                        name="下移"
                        v-btnlimit="'已审文章-下移'"
                        @click="handlemovedown(action.id)"
                        size="small"
                        type="default"
                        class="pxkeji_dro_btn"
                />
              </a-menu-item>
                     <a-menu-item key="8">
                <pxkeji-btn
                        name="取消置顶"
                        v-btnlimit="'已审文章-取消置顶'"
                        @click="cancle(action.id)"
                        size="small"
                        type="default"
                        class="pxkeji_dro_btn"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'已审文章-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>
    <a-modal
      title="SEO配置"
      v-model="seo.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <seoComponent @callbackMethod="hide" :sourceId="seo.sourceId" :sourceType="seo.sourceType" />
    </a-modal>
    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :sta="true" :infos="addedit.info" :type="addedit.type" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./articleInfo.vue"; //新增编辑
import seoComponent from "../system/seo.vue"; //SEO
const columns = [
  // {
  //   dataIndex: "id",
  //   key: "id",
  //   align: "center",
  //   title: "编号"
  // },
  {
    dataIndex: "title",
    key: "title",
    align: "center",
    title: "资讯标题",
    width: "23%"
  },
  {
    dataIndex: "tag",
    key: "tag",
    align: "center",
    title: "标签"
  },
  {
    dataIndex: "articlecategoryName",
    key: "articlecategoryName",
    align: "center",
    title: "栏目"
  },
  {
    dataIndex: "addtime",
    key: "addtime",
    align: "center",
    title: "提交时间"
  },
  {
    dataIndex: "author",
    key: "author",
    align: "center",
    title: "作者"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    dataIndex: "priority",
    key: "priority",
    align: "center",
    title: "置顶",
    scopedSlots: { customRender: "priority" }
  },
  {
    dataIndex: "auditstatus",
    key: "auditstatus",
    align: "center",
    title: "审核状态",
    scopedSlots: { customRender: "auditstatus" }
  },
  {
    title: "操作",
    key: "action",
    align: "left",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "advertzonelist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      seo:{
        visible: false,
        sourceId:0,
        sourceType:0
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          cateArr: [],
          title: "",
          status: "",
          cate: ""
        },
        cateData: []
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    Info,
    seoComponent,
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
      this.GetCateList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    handlemoveup(id) {
      this.isloading = true;
      this.$api.article
              .upOrDown(id,1)
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  that.$message.success(res.errorMsg);
                 this.GetList();
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });

    },
    handlemovedown(id) {
      this.isloading = true;
      this.$api.article
              .upOrDown(id,2)
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  that.$message.success(res.errorMsg);
                  this.GetList();
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });

    },
    toggle() {
      this.expand = !this.expand;
    },
    setSeo(id){
      this.seo.sourceId=id;
      this.seo.sourceType=3;
      this.seo.visible=true;
    },
    hide(){
      this.seo.visible=false;
    },
    cancle(id){
      this.$confirm({
        title: "您确定要执行取消置顶操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.article
                  .cancleTop(id)
                  .then(res => {
                    that.isloading = false;
                    if (res.errorCode == that.$msg.responseCode.success) {

                      that.$message.success(res.errorMsg);
                      this.GetList()
                    }
                    else {
                      that.$message.error(res.errorMsg);
                    }
                  })
                  .catch(() => {
                    that.isloading = false;
                    that.error();
                  });
        },
        onCancel() {}
      });


    },
    top(id){
      this.$confirm({
          title: "您确定要执行置顶操作吗?",
          okText: "确定",
          okType: "danger",
          cancelText: "我再想想",
          onOk() {
            that.isloading = true;
            that.$api.article
              .top(id)
              .then(res => {
                that.isloading = false;
                if (res.errorCode == that.$msg.responseCode.success) {

                   that.$message.success(res.errorMsg);
                   this.GetList()
                }
                else {
                   that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                that.isloading = false;
                that.error();
              });
          },
          onCancel() {}
        });

      
    },
      treeChange(val) {
      this.where.keyword.cate=val[val.length-1];
    },
    GetCateList() {
      //获取列表
      this.isloading = true;
      this.$api.articlecategory
        .getTree()
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.where.keyword.cateArr = res.data;
            //console.log('asd',this.where.keyword.type)
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    
    // getcategorylist() {
    //   this.isloading = true;
    //   this.$api.articlecategory
    //     .getAll()
    //     .then(res => {
    //       this.isloading = false;
    //       if (res.errorCode == this.$msg.responseCode.success) {
    //         this.where.cateData = res.data;
    //       }
    //       // else {
    //       //   this.error(res.errorMsg);
    //       // }
    //     })
    //     .catch(() => {
    //       this.isloading = false;
    //       this.error();
    //     });
    // },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.article
        .pageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.title,
          this.where.keyword.cate,
          "",
          "",
          "",
          -1,
          "",
          this.where.keyword.status
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    /*审核查看 */
    showInfo(info, type) {
      //打开弹出框
      this.addedit.visible = true;
      this.addedit.title = type == 1 ? "查看" : "审核";

      this.addedit.info = info;
      this.addedit.type = type;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /**单个启用禁用 */
    handleStatus(ids, status) {
      if (status == 0) {
        this.$confirm({
          title: "您确定要执行禁用的操作吗?",
          okText: "确定",
          okType: "danger",
          cancelText: "我再想想",
          onOk() {
            that.handleProhibit(ids, 0);
          },
          onCancel() {}
        });
      } else {
        that.handleProhibit(ids, 1);
      }
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.article
        .updateStatus(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.article
            .removeById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /** 批量删除 */
    batchDelete() {
      this.$confirm({
        title: "您确定要执行批量删除的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.article
            .removeByIds(that.selectRows.join(","))
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /**反审 */
    recheckInfo(id) {
      this.$confirm({
        title: "您确定要反审此条记录么?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.loadingTip = "审核中...";
          that.$api.article
            .audit(id, 0, "")
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

